<template>
    <w-flex class="row justify-center">
        <h1 class="pt12">Page Not Found</h1>
    </w-flex>
</template>